import { useContext, useMemo } from 'react';
import * as _ from 'lodash';
import moment from 'moment';
import { DataContext } from '../context/data-context';
import { useApi } from './api';

export function useLatestCoverage(limit = 5) {
  const { league } = useContext(DataContext);
  const [data, loading, error] = useApi(
    `fotbollplay?channel=${league}&category=official`
  );

  const videos = useMemo(
    () =>
      _.orderBy(
        data?.filter((item) =>
          moment(item.date).isAfter(moment().subtract(1, 'month'))
        ),
        'date',
        'desc'
      ).splice(0, limit),
    [data, limit]
  );

  return [videos, loading, error];
}
